// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "人工智能概论",
      "tec": "田卫华",
      "week": "4-9周",
      "add": "实训楼F座101自控"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "汽轮机控制系统",
      "tec": "郭南",
      "week": "4-9周",
      "add": "实训楼F座401信息"
    },
    0,
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "自动化专业外语",
      "tec": "沈震",
      "week": "10-15周",
      "add": "实训楼F座101自控"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "人工智能概论",
      "tec": "田卫华",
      "week": "4-9周",
      "add": "实训楼F座401信息"
    },
    {
      "sub": "汽轮机控制系统",
      "tec": "郭南",
      "week": "4-9周",
      "add": "实训楼F座101自控"
    },
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "自动化专业外语",
      "tec": "沈震",
      "week": "10-15周",
      "add": "实训楼F座101自控"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
